<style lang="scss" scoped>
.i-30 {
    width: 30px;
}
</style>

<template>

    <div class="row mt-15">
        <div class="col-12 col-md-4 col-lg-3">
            <box :padding="0">
                <template slot="content">
                    <router-link class="fw-semi-bold p-30 border-bottom" active-class="svg-orange text-primary" :to="{ name: 'profile-settings' }">
                        <i-profile class="i-30 mr-30"></i-profile>
                        {{ $t('profile.profile') }}
                    </router-link>
                    <router-link class="fw-semi-bold p-30 border-bottom" active-class="svg-orange text-primary" :to="{ name: 'profile-company' }">
                        <i-companies class="i-30 mr-30"></i-companies>
                        {{ $t('profile.company') }}
                    </router-link>
                    <router-link class="fw-semi-bold p-30 border-bottom" active-class="svg-orange text-primary" :to="{ name: 'profile-payment' }">
                        <i-payment class="i-30 mr-30"></i-payment>
                        {{ $t('profile.payments') }}
                    </router-link>
                    <router-link class="fw-semi-bold p-30 border-bottom" active-class="svg-orange text-primary" :to="{ name: 'profile-notifications' }">
                        <i-bell class="i-30 mr-30"></i-bell>
                        {{ $t('profile.notifications') }}
                    </router-link>
                    <a href="#" class="fw-semi-bold p-30" @click="forceLogout">
                        <i-logout class="i-30 mr-30"></i-logout>
                        {{ $t('profile.logout') }}
                    </a>
                </template>
            </box>
        </div>
        <div class="col-12 col-md-8 col-lg-9">
            <router-view />
        </div>
    </div>

</template>

<script>

export default {
    methods: {
        forceLogout() {
            this.$store.commit("fleet/RESET_FLEET");
            this.$store.commit("chat/RESET_CHAT");
            this.$store.commit("shipments/RESET_SHIPMENTS");
            this.$store.commit("auth/RESET_AUTH");
            this.$router.push("/login");
        }
    }
};
</script>
